"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createNamedSignals = void 0;
const signals_1 = require("@wix/services-definitions/core-services/signals");
const createNamedSignals = ({ config, getService, }) => {
    const signalRegistry = {};
    const signalsService = getService(signals_1.SignalsServiceDefinition);
    // set initial state if exists
    if (config.initialStore) {
        Object.entries(config.initialStore).forEach(([name, value]) => (signalRegistry[name] = signalsService.signal(value)));
    }
    config.onRemoteChange?.((remoteName, remoteValue) => {
        const signal = signalRegistry[remoteName];
        if (!signal) {
            return;
        }
        signal.set(remoteValue);
    });
    return {
        ...signalsService,
        signal: (initialValue, name) => {
            if (!(name in signalRegistry)) {
                signalRegistry[name] = signalsService.signal(initialValue);
            }
            const signal = signalRegistry[name];
            return {
                ...signal,
                set: (value) => {
                    signal.set(value);
                    config.updateRemote?.(name, value);
                },
            };
        },
    };
};
exports.createNamedSignals = createNamedSignals;
//# sourceMappingURL=namedSignals.js.map